import React from 'react';
import cssIf from '../../../scripts/helpers/class.add.if';
import './table.card.scss';
import Button from '../button';
import { format } from 'date-fns';

const TableCard = ( props ) => {

  const   {
    
    action,
    email = "",
    phone = 0, 
    company = "",
    created_at = "",
    allnames = ""
  
  } = props;

  return (

    <div className="table-card">

      <div className="table-card__header flex justify-between">

        <p className="table-card__header__date">{ created_at }</p>
        
        {/* <div className="table-card__header__liner" /> */}
        {/* //TODO */}
        {/* <p className="table-card__header__measures">Доступ активен до: 12.03.2025</p> */}


      </div>

      <p className="table-card__company">{ company }</p>

      <div className="table-card__allnames flex" style = {{ rowGap: '4px', columnGap: '4px', flexWrap: 'wrap', paddingRight: '10px'}}>
        <div>{ allnames }</div>
        <a 
          href={`mailto:${ email }`} 
          className="table-card__allnames"
          style = {{ marginLeft: 0 }}
        >
          { email }
        </a>
      </div>

      <div className="table-card__footer flex relative">

        <img 
        
          src="/images/icons/ph_phone.png" 
          className="icon-phone" 
          onClick={ () => { window.open(`tel:${ phone }`) }}
          
        />
        
        <div className="table-card__footer__liner" />
        <a href={`tel:${ phone }`} className="table-card__footer__phone">{ phone }</a>

        <Button 
        
          action = { action }
          text="подробнее"
          className="table-card__footer__button"
        
        />

      </div>

    </div>

  );

 }

export default TableCard;